import img18a from '../../../assets/gallery/18a/18a-01-HOME_ST-2018-199x133cm-oleo-sobre-tela.jpg';
import img18b from '../../../assets/gallery/18a/18a-02_ST-2018-173x130cm-oleo-sobre-tela.jpg';
import img18c from '../../../assets/gallery/18a/18a-03_ST-2018-166x133cm-oleo-sobre-tela.jpg';
import img18d from '../../../assets/gallery/18a/18a-04_ST-2018-196x159cm-oleo-sobre-tela.jpg';
import img18e from '../../../assets/gallery/18a/18a-05_Rayos-y-plano-2018-1925x134mm-oleo-sobre-tela.jpg';
import img18f from '../../../assets/gallery/18a/18a-06_ST-2018-1638x1334mm-oleo-sobre-tela.jpg';
import img18g from '../../../assets/gallery/18a/18a-07_ST-2018-1918x1435mm-oleo-sobre-tela.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "199 x 133 cm",
    pictureSrc: img18a,
    description: "2018",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "173 x 130 cm",
    pictureSrc: img18b,
    description: "2018",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "166 x 133 cm",
    pictureSrc: img18c,
    description: "2018",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "196 x 159 cm",
    pictureSrc: img18d,
    description: "2018",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "192,5 x 134 cm",
    pictureSrc: img18e,
    description: "2018",
    orientation: "v"
  },
  {
    id: 6,
    title: "",
    dimensions: "163,8 x 133,4 cm",
    pictureSrc: img18f,
    description: "2018",
    orientation: "v"
  },
  {
    id: 7,
    title: "",
    dimensions: "191,8 x 143,5 cm",
    pictureSrc: img18g,
    description: "2018",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/18a/data18a.js